module.exports = __webpack_public_path__ + "static/media/logo-mobion.b0e2dd57.png";